import { Routes, Route } from 'react-router-dom'
import { AppShell, LoadingOverlay } from '@mantine/core'
import Layout from '@/components/Layout'
import Dashboard from '@/pages/Dashboard'
import Entries from '@/pages/Entries'
import Projects from '@/pages/Projects'
import Calendar from '@/pages/Calendar'
import RoleManagement from '@/pages/RoleManagement'
import EntryManagement from '@/pages/EntryManagement'
import Reporting from '@/pages/Reporting'
import Settings from '@/pages/Settings'
import Information from '@/pages/Information'
import Login from '@/pages/Login'
import AuthCallback from '@/pages/AuthCallback'
import { useAuth } from '@/hooks/useAuth'
import { useTimeTracking } from '@/hooks/useTimeTracking'
import { useUserSettings } from '@/hooks/useUserSettings'
import { TimeTrackingProvider } from '@/contexts/TimeTrackingContext'
import { UserSettingsProvider } from '@/contexts/UserSettingsContext'
import { TimeEntriesCacheProvider } from '@/contexts/TimeEntriesCache'

function AppContent() {
  const { user, loading } = useAuth()
  const timeTracking = useTimeTracking(!!user)
  const userSettings = useUserSettings(!!user)

  if (loading) {
    return <LoadingOverlay visible={true} />
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/auth" element={<AuthCallback />} />
        <Route path="*" element={<Login />} />
      </Routes>
    )
  }

  return (
    <UserSettingsProvider userSettings={userSettings}>
      <TimeTrackingProvider timeTracking={timeTracking}>
        <AppShell
          header={{ height: 60 }}
          navbar={{ width: 300, breakpoint: 'sm' }}
          padding="md"
        >
          <Layout>
            <Routes>
              <Route path="/auth" element={<AuthCallback />} />
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/entries" element={<Entries />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/calendar" element={<Calendar />} />
              <Route path="/role-management" element={<RoleManagement />} />
              <Route path="/entry-management" element={<EntryManagement />} />
              <Route path="/reporting" element={<Reporting />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/information" element={<Information />} />
            </Routes>
          </Layout>
        </AppShell>
      </TimeTrackingProvider>
    </UserSettingsProvider>
  )
}

export default function App() {
  return (
    <TimeEntriesCacheProvider>
      <AppContent />
    </TimeEntriesCacheProvider>
  )
} 